/*! Copyright (c) Safe As Milk. All rights reserved. */
function tabClick(e) {
    if (e.keyCode === 9) {
        document.body.classList.add("js-using-tab");
        window.removeEventListener("keydown", tabClick);
    }
}

window.addEventListener("keydown", tabClick);

window.theme ??= {};

window.theme.wrapRteTables = (rootElement = document) => {
    const wrapTable = (el, wrapper) => {
        el.parentNode.insertBefore(wrapper, el);
        wrapper.appendChild(el);
    };
    rootElement.querySelectorAll(".rte table").forEach((table => {
        if (table.closest(".js-theme-utility-rte-table-wrap")) return;
        const tableWrapper = document.createElement("div");
        tableWrapper.classList.add("js-theme-utility-rte-table-wrap");
        tableWrapper.setAttribute("style", "overflow:auto;-webkit-overflow-scrolling:touch");
        wrapTable(table, tableWrapper);
    }));
};

window.theme.wrapRteTables();

window.theme.openExternalLinksInNewTab = () => {
    const currentHostname = window.location.hostname.replace(/^www\./, "");
    const ignoredProtocols = [ "mailto:", "tel:", "sms:", "javascript:" ];
    const ensureRelSecurity = anchor => {
        const relValues = new Set((anchor.getAttribute("rel") || "").split(/\s+/).filter(Boolean));
        relValues.add("noopener");
        relValues.add("noreferrer");
        anchor.setAttribute("rel", Array.from(relValues).join(" "));
    };
    const isExternal = href => {
        try {
            const parsedUrl = new URL(href, window.location.href);
            if (ignoredProtocols.includes(parsedUrl.protocol)) return false;
            if (parsedUrl.protocol !== "http:" && parsedUrl.protocol !== "https:") return false;
            const targetHostname = parsedUrl.hostname.replace(/^www\./, "");
            return targetHostname !== currentHostname && !targetHostname.endsWith(`.${currentHostname}`);
        } catch (error) {
            return false;
        }
    };
    const patchAnchor = anchor => {
        if (!(anchor instanceof HTMLAnchorElement)) return;
        if (anchor.hasAttribute("download")) return;
        const href = anchor.getAttribute("href");
        if (!href || href.startsWith("#")) return;
        if (!isExternal(anchor.href)) return;
        anchor.setAttribute("target", "_blank");
        ensureRelSecurity(anchor);
    };
    const patchTree = root => {
        if (!root) return;
        if (root instanceof HTMLAnchorElement) patchAnchor(root);
        if (root.querySelectorAll) {
            root.querySelectorAll("a[href]").forEach(patchAnchor);
        }
    };
    patchTree(document);
    const observer = new MutationObserver((mutations => {
        mutations.forEach((mutation => {
            mutation.addedNodes.forEach((node => {
                if (node.nodeType === Node.ELEMENT_NODE) patchTree(node);
            }));
        }));
    }));
    observer.observe(document.documentElement, {
        childList: true,
        subtree: true
    });
};

window.theme.openExternalLinksInNewTab();

const scrollEndSupported = typeof window === "undefined" ? true : "onscrollend" in window;

if (!scrollEndSupported) {
    import("scrollyfills");
}
//# sourceMappingURL=global.js.map
